import { render, staticRenderFns } from "./BarOrientationConsultationsMDTChart.vue?vue&type=template&id=154ab8b6&"
import script from "./BarOrientationConsultationsMDTChart.vue?vue&type=script&lang=ts&"
export * from "./BarOrientationConsultationsMDTChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports